<script setup>
import { ref, reactive, watch ,toRefs,computed,onMounted } from "vue";
// import { useScrollToc } from "@/composables/scroll-toc";
import { useUserStore } from "@/stores/user";
import { useCrfStore } from "@/stores/crf";
import TGJC from "@/components/TGJC.vue";
import BS from "@/components/BS.vue";
import YBXX from "@/components/YBXX.vue";
import FSXX from "@/components/FSXX.vue";
import XCGJNCG from "@/components/XCGJNCG.vue";
import NXGN from "@/components/NXGN.vue";
import XSHJC from "@/components/XSHJC.vue";
import AFP from "@/components/AFP.vue";
import YGHCVHIV from "@/components/YGHCVHIV.vue";
import ANAANCA from "@/components/ANAANCA.vue";
import MYQDB from "@/components/MYQDB.vue";
import JZXGN from "@/components/JZXGN.vue";
import XDT from "@/components/XDT.vue";
import WJ from "@/components/WJ.vue";
import FIBROSCAN from "@/components/FIBROSCAN.vue";
import FIBROTOUCH from "@/components/FIBROTOUCH.vue";
import FBFSMJMBC from "@/components/FBFSMJMBC.vue";
import FBCT from "@/components/FBCT.vue";
import MJMCTV from "@/components/MJMCTV.vue";
import GZZQMR from "@/components/GZZQMR.vue";
import MRCP from "@/components/MRCP.vue";
import HVPGCD from "@/components/HVPGCD.vue";
import BFXY from "@/components/BFXY.vue";
import QTBSZL from "@/components/QTBSZL.vue";
import JWTIPSZL from "@/components/JWTIPSZL.vue";
import JWWKSSZL from "@/components/JWWKSSZL.vue";
import JWNJZL from "@/components/JWNJZL.vue";
import JWYWZL from "@/components/JWYWZL.vue";
import GZSDC from "@/components/GZSDC.vue";
import QWXZJYCX from "@/components/QWXZJYCX.vue";
import BLSJJL from "@/components/BLSJJL.vue";
import GZZQCT from  "@/components/GZZQCT.vue";
import BLBG from  "@/components/BLBG.vue";
import ZG from "@/components/ZG.vue";
// import { useUserStore } from '../stores/user'
import check from "./check.vue";
import { useCommonStore } from "@/stores/common";
import InclusionCriteria from "@/components/InclusionCriteria.vue";
import ExcludeCriteria from "@/components/ExcludeCriteria.vue";
import { ElMessage } from "element-plus"
// import screen from "@/assets.screen.js"
const emits = defineEmits(["create", "open", "close", "update"]);

// 定义组件属性
const props = defineProps({
  // psvd_field.id
  id: null,
  // 选择的患者
  patient: {},
  // 选择的访视期(根据访视日期的module 来判断需要展示的选项)
  crfForm: {},
  crfForms:{
    type:Array,
    default:[]
  },
  showDialog: {
    type: Boolean,
    default: false
  }
});
// console.log(props.id,'crfid')
// 对话框的显示状态
const dialogVisible = ref(props.showDialog);
const commonStore = useCommonStore();
let crfFormIndex = ref(null)
const crfFormses = reactive(props.crfForms)

// 拿到医生信息
const user = useUserStore()
// console.log(userId.id,"医生idcrf");

// 表单对象
const model = reactive({
  user_id:user.id,
  id: props.id,
  fields: {},
  checkdata:{},
  questiondata:[],
});

//实验室检查适用筛选期数据
// let lab = ref(false)
model.lab ??= true

let btnshow = ref(false)
// console.log(model,'model');
const formRef = ref();
const formRule = reactive({});
const IdCard = ref()
// 提交上传中提示
let crfLoading = ref(false)

let stag = ref(false)
// 暂存
const Staging = (e,isStagin)=>{
  // console.log(isStagin,"点击暂存")
  model.fields.isStagin ??= []
  model.fields.isStagin.push(isStagin)
  stag.value = true
  // return

    submitForm(e)
}
// 提交(v试表)
const submitForm = async (formEl,isStagin) => {

  let index =  model.fields.isStagin? model.fields.isStagin.indexOf(isStagin):-1
  if (index > -1) {
    model.fields.isStagin.splice(index,1)
  }
  console.log(formEl,'formEl')
  if (!formEl) return;

    yanzheng(formEl)
};
//（卫语句，链式操作，新的js语法，三目运算短路的一些写法）
// 表单验证（里面写身份证验证和是否符合入选标准和排除标准）
const yanzheng =async (formEl)=>{
  const store = useCrfStore();
  // console.log(props.crfForm,"访视日期");

  formEl.validate( async (valid, fields) => {

    if (crfFormses[crfFormIndex.value].type == '筛选期（肝穿前96周内资料完整点）±2周'){

    }else if(stag.value){
      stag.value = false
    }else if(!valid ) return
      let show = null
      let select = true
      // 连续跳转需要判断第几个访视期
      // switch(crfFormses[crfFormIndex.value].name){
      //   case crfFormses[0].name:
      //     // console.log(model.fields['入选标准'],"入选标准的结果")
      //     // console.log(model.fields['入选标准']['入选标准：肝活检排除肝硬化'],"入选标准的结果")、
      //     if (model.fields['入选标准']['入选标准：极早期患者'] == '是') {
      //       show = 1
      //     break;
      //     }
      //     // 入选标准为满足1+2或1+4或满足1+3+5
      //     if(model.fields['入选标准']['入选标准：肝活检排除肝硬化'] == '否'){
      //       select = false

      //       ElMessage.error('该病例不满足入选标准，标准为满足1+2或1+4或满足1+3+5')
      //     }else{
      //         if (model.fields['入选标准']['入选标准：临床存在特异性门脉高压征象'] == '是'
      //         || model.fields['入选标准']['入选标准：组织学表现为特异性PSVD'] == '是'
      //         ||(model.fields['入选标准']['入选标准：临床存在非特异性门脉高压征象'] == '是' && model.fields['入选标准']['入选标准：组织学表现为非特异性'] == '是') ) {

      //         }else{
      //             select = false
      //             // ElMessage.error('该病例不满足入选标准，标准为满足1+2或1+4或满足1+3+5')
      //         }
      //     }
      //     show = 1
      //     break;
      //   case crfFormses[1].name:
      //     if (model.fields['排除标准']['极早期患者'] == '是') {
      //       show = 2
      //     break;
      //     }
      //     if(Object.values(model.fields['排除标准']).includes('是')){
      //       select = false
      //       ElMessage.error('该病例不满足排除标准，标准为所有排除项为否')
      //     }
      //     show = 2
      //     break;
      //   case crfFormses[2].name:
      //     show = 3
      //     break;
      //   case crfFormses[3].name:
      //     show = 4
      //     break;
      //   case crfFormses[4].name:
      //     show = 5
      //     break;
      //   case crfFormses[5].name:
      //     show = 6
      //     break;
      //   case crfFormses[6].name:
      //     show = 7
      //     break;
      //   case crfFormses[7].name:
      //     show = 8
      //     break;
      //   case crfFormses[8].name:
      //     show = 9
      //     break;
      //   // ----------
      //   case crfFormses[9].name:
      //     show = 10
      //     break;
      //   case crfFormses[10].name:
      //     show = 11
      //     break;
      //   case crfFormses[11].name:
      //     show = 12
      //     break;
      //   case crfFormses[12].name:
      //     show = 13
      //     break;
      //   case crfFormses[13].name:
      //     show = null
      //   break;
      // }
      // console.log("表单数据", model.recordId, model.fields);
      // 判断入选标准
      if (!select) return

      // 表单检验完成后，调用子方法，判断身份证后六位是否合法
      let idcard = await IdCard.value?.idCard()
      if(!idcard) return
      // 验证手机号
      if(!IdCard.value.phonefun()) return
      console.log(btnshow.value, 'btnshow.value')
      //点击适用可以不用填写访视日期
      if(!['排除标准','入选标准'].includes(props.crfForm.type) && (!model.fields[props.crfForm.type]['访视日期'] && !btnshow.value)){
          return ElMessage.error('请填写访视日期！')
      }
      model.fields.isHideBtn = btnshow.value
      crfLoading.value = true

      // 判断全部的状态
      model.fields.vistisState??= false
      let state = 0
      crfFormses.forEach((e,i) =>{
        if(model.fields[e.type]){
          state++
        }
      })
      if(state == crfFormses.length){
        model.fields.vistisState = true
        // model.user_id = user.id
      }
      console.log(model, 'model')
      let res = await store.update({...model,user_id: user.id})
      if (res.result != "success"){
        crfLoading.value = false
        stag.value = false
        return ElMessage.error(res.msg || '提交失败！')

      }
        emits("update", res.data);
        // 满足连续填写不关闭页面

      // console.log(model.fields[props.crfForm.type]['访视日期'],"查看访视日期")
      crfLoading.value = false //上传加载条
      /*暂存不关闭页面*/
      if(stag.value){
          stag.value = false
          return ElMessage.success( '暂存成功！')
      }
      setTimeout(() => {

        dialogVisible.value = false;//关闭页面
      }, 0);
      if(!show) return
      crfFormIndex.value = show
      commonStore.index = show
      // 正常点击和跳转都需要请求(患者最新的数据)
      let getdata = await commonStore.getData(props.id)
      model.id = getdata.data?.id;
      model.fields = getdata.data?.fields;
      if (typeof (model.fields[`${crfFormses[crfFormIndex.value].type}`]) === "undefined") {
        model.fields[`${crfFormses[crfFormIndex.value].type}`] = {};
      }

      if(stag.value){
        return
      }
      setTimeout(() => {

        dialogVisible.value = false;
      }, 0);

   });
}

//第几次核查
const is_fully_checked = ref(false)

//访视期内有多少核查按钮
const checkcount = ref(0)


let no_access = ref(1)
// 单独点击访视期，确定是哪一块的内容（重点，解决自动跳转关闭，点击上一个报错的问题）
watch(() => props.showDialog, (newValue, oldValue) => {
  dialogVisible.value = newValue;
  if (newValue === true) {
    crfFormses.forEach((item,index) => {
      if(props.crfForm.name == item.name) {
        crfFormIndex.value = index;
        commonStore.index = index
      }
    })
    // 正常点击和跳转都需要请求(患者最新的数据)

    commonStore.getData(props.id).then(async (res) => {
      console.log(res.data,"请求的个人数据");
      // debugger
      no_access.value = res.data.modifiable
      model.id = res.data.id;
      model.fields = res.data.fields;
      model.user_id = res.data.user_id;
      console.log(model.fields,'质疑信息');
      // 强制所有数据都启用核查和二次核查（包括老数据）
      model.fields.ischeck = '是'
      model.fields.ischeck2 = '是'

      // debugger
      //筛选期以后才有质疑
      if(crfFormIndex.value > 1){
          const data = `field_id=${props.id}&period=${props.crfForm.type}&user_id=${user.id}`;
        let question =await commonStore.getquestionlist(data)
          // console.log(question,'请求的质疑数据');
          model.questiondata = question.data

        //访视期核查数据
        if(res.data.fields?.ischeck == '是' ){
          const data2 = `field_id=${props.id}&period=${props.crfForm.type}&check_round=1`
          //第一次是否核查完毕
          let obj = await commonStore.getcheckall(data2)
          //如果第一核查完毕，并且选了第二次核查，才查第二次核查数据，否则还查第一次数据
          console.log(obj.data, '第一次核查是否完成');
          let round = ''
          // console.log(res.data.fields?.ischeck2,model.fields, '第二次核查');
          // debugger
          if(obj.data.is_fully_checked && res.data.fields?.ischeck2 == '是'){
              round = '2'
              commonStore.ischecke = 2
              console.log(obj.data, res.data.fielids?.ischeck2, '第二１次核查');
          }else{
              round = '1'
              commonStore.ischecke = 1
              console.log(obj.data, res.data.fielids, '第二２次核查');

          }
          const data3 = `field_id=${props.id}&period=${props.crfForm.type}&check_round=${round}`

          let res1 = await commonStore.getcheck(data3)

          console.log(res1,'请求的访视期核查数据');
          commonStore.is_fully_checked = res1.is_fully_checked
          model.checkdata.ischeck = model.fields?.ischeck;
          // model.checkdata.ischeck2 = model.fields?.ischeck2;
          model.checkdata.data = res1.data
        }
      }

      //ctp逻辑
      setctps()
      crfFormses[3].module = crfFormses[3].moduleOld
      btnshow.value = false
      if (typeof (model.fields[`${crfFormses[crfFormIndex.value]?.type}`]) === "undefined") {
        model.fields[`${crfFormses[crfFormIndex.value]?.type}`] = {};
      }
      setTimeout(() => {
        dialogVisible.value = true;

      }, 0);
    });
  }
},{immediate: true} );

// console.log(crfFormses,crfFormIndex.value,"dayin")

const handleOpenDrawer = () => {
  emits("open");
};
const handleCloseDrawer = () => {
  emits("close");
  setTimeout(() => {

    dialogVisible.value = false;
  }, 0);

};
// js锚点目录
const goanchor = (e)=>{
  document.querySelector(e).scrollIntoView({
    behavior:'smooth'
  })
};
// 全局适用筛选期逻辑
// 317-318
// 354-371
// 470
// 515-518

// 访视期放出来
// 是否适用
// watch(btnshow,(newval,oldval)=>{
//   // console.log(newval,oldval,"首次打印")
//   // console.log(crfFormses[3],'crf3')

//   if (newval) {
//       // 拿到不和筛选期一样的组件的集合
//       let arrs = ['YBXX']
//       crfFormses[3].moduleOld.forEach((item,index)=>{
//           // 如果不和筛选期一样，就保存
//           if (crfFormses[2].module.includes(item)) return
//           arrs.push(item )
//         })
//       // arrnew = arrs
//       crfFormses[3].module = arrs
//   } else{
//     crfFormses[3].module = crfFormses[3].moduleOld
//   }
// })
const btn = (e)=>{
  btnshow.value = e
  // model.fields.isHideBtn = e
};
const screencrf = reactive({
  size :80,
  rowWidth : '',
  colsapn :'',
  labelWidth : ''
})
const Ctpitem = ref([])
const ctpMissing = ref([]) // CTP缺失项
const setctps = ()=>{
  //ctp
  // 清空之前的数据
  Ctpitem.value = []
  missObj.value = []
  missKey.value = []
  ctpMissing.value = []
  
  let sum = 0
  let ctp = model.fields[crfFormses[crfFormIndex.value].type]?.ctp
  let hasInvalidCtp = false
  
  // 固定的5个CTP指标
  const ctpKeys = ['腹水', '肝性脑病', '血清白蛋白', '血清胆红素', 'INR']
  
  // 检查 ctp 对象是否存在
  if(!ctp || Object.keys(ctp).length === 0){
    computedCtp.value = null
    // 完全无数据时，每一项都显示"无效数据(由于缺项无法计算当前评分)"
    for (const key of ctpKeys) {
      ctpMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
    }
  } else {
    // CTP对象存在，按固定顺序处理5个指标
    for (const key of ctpKeys) {
      // 检查该指标是否存在
      if (ctp[key] === undefined) {
        // 不存在的指标显示无效数据
        ctpMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
        hasInvalidCtp = true
        continue
      }
      
      // 检查是否可以转换为有效数字
      let ctpValue = Number(ctp[key])
      if(isNaN(ctpValue) || !isFinite(ctpValue)){
        hasInvalidCtp = true
        ctpMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
      } else {
        // 有效数据，添加到显示列表
        Ctpitem.value.push(`${key} : ${ctp[key]}`)
        sum += ctpValue
      }
    }
    
    // 如果有无效项，标记为缺失数据
    if(hasInvalidCtp){
      computedCtp.value = null
    } else {
      computedCtp.value = sum
    }
  }

  // MELD评分处理
  Melditem.value = []
  meldMissing.value = []
  
  // 固定的3个MELD指标
  const meldKeys = ['总胆红素', 'INR', '血肌酐']
  
  let meldData = model.fields[crfFormses[crfFormIndex.value].type]?.meld
  let hasInvalidMeld = false
  
  // 检查 meld 对象是否存在
  if(!meldData || Object.keys(meldData).length === 0){
    computedMeld.value = null
    // 完全无数据时，每一项都显示"无效数据(由于缺项无法计算当前评分)"
    for (const key of meldKeys) {
      meldMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
    }
  } else {
    // MELD对象存在，按固定顺序处理3个指标
    for (const key of meldKeys) {
      // 检查该指标是否存在
      if (meldData[key] === undefined) {
        // 不存在的指标显示无效数据
        meldMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
        hasInvalidMeld = true
        continue
      }
      
      // 检查是否为有效数字
      let meldValue = meldData[key]
      if(typeof meldValue === 'string' && (meldValue.includes('缺') || meldValue.includes('无效') || meldValue.includes('错误'))){
        // 如果是错误信息字符串
        hasInvalidMeld = true
        meldMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
      } else if(!isFinite(Number(meldValue)) || isNaN(Number(meldValue))) {
        // 无法转换为有效数字
        hasInvalidMeld = true
        meldMissing.value.push(`${key} : 无效数据(由于缺项无法计算当前评分)`)
      } else {
        // 有效数据，添加到显示列表
        Melditem.value.push(`${key} : ${meldValue}`)
      }
    }
    
    // 检查计算结果
    let value = meldData.value
    if (value && isFinite(value) && !isNaN(value)) {
      computedMeld.value = Math.floor(value)
    } else {
      computedMeld.value = null
      hasInvalidMeld = true
    }
  }
  
  // 保留原有的missKey和missObj用于兼容性（如果其他地方还在使用）
  missKey.value = model.fields[crfFormses[crfFormIndex.value].type]?.meld?.missKey || []
  missObj.value = []
  let obj = model.fields[crfFormses[crfFormIndex.value].type]?.meld?.missObj
  for (const key in obj) {
    if (!(model.fields[crfFormses[crfFormIndex.value].type]?.meld?.value)){
      missObj.value.push(`${key + ' : ' +obj[key]}`)
    }
  }
}
//ctp展示
let isctpshow = ref(false)
let ismeldshow = ref(false)


//缺失项
let missKey = ref([])
let missObj = ref([])
const meldMissing = ref([]) // MELD缺失项
const Melditem = ref([]) // MELD有效项
const computedCtp = ref('')
//computedMeld展示
const computedMeld = ref('')

//  根据屏幕的大小设置弹窗和表格的大小
const watchWindowSize = ()=>{

  // 获取窗口的宽度和高度，不包括滚动条
  var w = document.documentElement.clientWidth;
  var h = document.documentElement.clientHeight;
  // 打印结果
  // result.innerHTML = "宽: " + w + ", " + "高: " + h

  if (w > 1000) {
    // 弹窗的宽度设置80% 否则100%
    screencrf.size = 80
    screencrf.rowWidth = 100
    screencrf.colsapn= 15
    screencrf.labelWidth = 250
  }else{
    screencrf.size = 100
    screencrf.rowWidth = 200
    screencrf.colsapn = 24
    // screencrf.labelWidth = 160
  }
  // console.log(screencrf.size,screencrf.rowWidth,screencrf.colsapn,screencrf.labelWidth)

}

watchWindowSize()
window.onresize = ()=>{
  watchWindowSize()

}
// 窗口变化事件
window.onload = ()=>{
// watchWindowSize()
};


//一键核查
const allshow = ref(false)
const allcheck = ()=>{
  allshow.value = true
}
//一键核查
const allcheck1 = ()=>{
    const data = {
      "field_id": model.id,
      "user_id": user.id,
      "check_round":commonStore.ischecke ,
      "check_status": 1,
      "period": crfFormses[crfFormIndex.value].type
    }
    commonStore.allcheck(data).then(async res1=>{
        console.log(res1)

         const data = `field_id=${props.id}&period=${props.crfForm.type}&check_round=${ commonStore.ischecke}`
        let res = await commonStore.getcheck(data)
          // console.log(res,'请求的访视期核查数据');
          model.checkdata.ischeck = model.fields?.ischeck;
          model.checkdata.data = res.data
          console.log(res,'check_status')
          commonStore.is_fully_checked = true

        setTimeout(() => {
          commonStore.checkdata = model.checkdata

        }, 1);
        allshow.value = false
    })
 }
const title =computed(() => {
    let index = crfFormIndex.value
    if(index == 2) return '既往治疗'
    else if(index == 3 && !btnshow.value) return '筛选期至V0期治疗补充'
    else if(index > 3) return `V${index - 4}期至V${index - 3}期治疗补充`
    else return ''
    // <h2 v-if="crfFormIndex == 2">既往治疗</h2>
    //                       <h2 v-else-if="crfFormIndex == 3 && !btnshow">筛选期至V0期治疗补充</h2>
    //                       <h2 v-if="crfFormIndex > 3">V{{ crfFormIndex - 4 }}期至V{{ crfFormIndex - 3 }}期治疗补充</h2>
  return crfFormses[index].name
})

// watch(commonStore.allcheckcount, (newVal, oldVal) => {
//     commonStore.allcheckcount
//     console.log(checkcount.value,'allcheckcount')
// })

;

</script>

<template>
      <el-drawer v-model="dialogVisible" :title="typeof(crfFormses[crfFormIndex]) ==='undefined' ? '':crfFormses[crfFormIndex].name"
                    :close-on-click-modal="false" :close-on-press-escape="false"
                    @close="handleCloseDrawer" direction="rtl" :size="`${screencrf.size}%`"
                    @open="handleOpenDrawer"
                    class="box">

          <p class="pp">{{ crfFormIndex == 3? '如果筛选期和基线间隔<14天，筛选期数据可以作为基线数据使用，请点击一下每个项目的适用数据。':'' }}</p>
          <p class="pp">{{ crfFormses[crfFormIndex]?.tip? `说明:肝穿后${crfFormses[crfFormIndex].tip}周（或${crfFormses[crfFormIndex].tip}周内最接近的一次）`:'' }}</p>
          <template v-if="dialogVisible">

                <el-row v-loading.fullscreen.lock="crfLoading" element-loading-text="信息提交中"  :style="`width:${screencrf.rowWidth}% ;overflow: auto;`">
                  <el-col :span="screencrf.colsapn">
                    <div :class="[no_access == 0?'no_access':'']"></div>
                    <section>

                      <!-- label-width="150px" -->
                      <el-form v-if="model.id" :model="model"  label-position="left" :label-width="`${screencrf.labelWidth}px`" ref="formRef"
                              :rules="formRule" :scroll-to-error="true" hide-required-asterisk="true"
                              :scroll-into-view-options="{ behavior: 'smooth', block: 'start', inline: 'nearest' }">
                              <div style="display: flex;align-items: center;margin-bottom: 20px;" v-if="!btnshow && crfFormIndex == 3">
                                <p >肝穿日期</p>
                                <FSXX v-if="crfFormses[crfFormIndex].module.includes('FSXX')" :index="crfFormIndex" :formModel="model" :type="crfFormses[crfFormIndex].type"></FSXX>

                              </div>

                        <!-- 适用筛选期数据 -->
                        <!-- <div v-if="crfFormIndex == 3" :class="{'v0_btns':screencrf.size == 100}">
                          <button @click.prevent="btn(true)"> 适用筛选期数据</button>
                          <button @click.prevent="btn(false)" style="margin-left: 20px;">不适用筛选期数据</button>
                        </div> -->

                        <!-- 分两部分，是/否 是筛选期数据 -->
                        <!-- 是筛选期数据 -->

                        <!-- 不是筛选期数据 -->

                        <!-- 一般信息 -->
                        <YBXX ref="IdCard"
                          v-if="crfFormses[crfFormIndex]?.module.includes('YBXX') && !crfFormses[crfFormIndex]?.module.includes('InclusionCriteria') && !crfFormses[crfFormIndex].module.includes('ExcludeCriteria')"
                          :mode="'whole'" :formModel="model" :fold="false" :foldbuttom="true" @phones="submitForm(formRef,crfFormses[crfFormIndex].type)"></YBXX>

                        <!-- 一般信息（只读）-->
                        <YBXX ref="IdCard"
                          v-if="crfFormses[crfFormIndex].module.includes('YBXX') && (crfFormses[crfFormIndex].module.includes('InclusionCriteria') || crfFormses[crfFormIndex].module.includes('ExcludeCriteria'))"
                          :mode="'part'" :readonly="true" :formModel="model"></YBXX>

                        <!-- 入选标准 -->
                        <inclusion-criteria v-if="crfFormses[crfFormIndex].module.includes('InclusionCriteria')" :formModel="model"
                                            :type="crfFormses[crfFormIndex].type"></inclusion-criteria>
                        <!-- 排除标准 -->
                        <exclude-criteria v-if="crfFormses[crfFormIndex].module.includes('ExcludeCriteria')" :formModel="model"
                                          :type="crfFormses[crfFormIndex].type"></exclude-criteria>

                        <!-- 访视信息 -->
                        <div class="picker">
                          <!-- 不是vo的访视日期 -->
                            <div :class="[no_access == 0?'no_access':'']" v-if="crfFormIndex >1 && crfFormIndex != 3">
                              <FSXX v-if="crfFormses[crfFormIndex].module.includes('FSXX')" :formModel="model" :index="crfFormIndex" :type="crfFormses[crfFormIndex].type"></FSXX>

                            </div>


                             <!-- 适用筛选期数据 -->
                              <!-- 先隐藏，后期再用 -->
                          <!-- <div v-if="crfFormIndex == 3" :class="{'v0_btns':screencrf.size == 100}">
                            <button @click.prevent="btn(true)"> 适用筛选期数据</button>
                            <button @click.prevent="btn(false)" style="margin-left: 20px;">不适用筛选期数据</button>
                          </div> -->
                        </div>

                        <!-- 病史 -->
                        <BS v-if="crfFormses[crfFormIndex].module.includes('BS')" :formModel="model" :type="crfFormses[crfFormIndex].type" :index="crfFormIndex" :btnshow="btnshow"></BS>

                        <!-- 体格检查 -->
                        <!-- <TGJC v-if="crfFormses[crfFormIndex].module.includes('TGJC')" :formModel="model" :type="crfFormses[crfFormIndex].type"></TGJC> -->

                        <!-- 其他伴随治疗 -->
                        <!-- <QTBSZL v-if="crfFormses[crfFormIndex].module.includes('QTBSZL')" :formModel="model" :type="crfFormses[crfFormIndex].type"></QTBSZL> -->

                        <!-- 现在只有访视期v1（首次发病点） 有既往伴随治疗 -->
                        <div style="display: flex; align-items: center;">
                          <h2>{{title}}</h2>
                          <check :period="crfFormses[crfFormIndex].type" :text="title" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
                        </div>

                        <!-- 既往TIPS治疗 （既往门脉高压介入治疗）-->
                        <JWTIPSZL v-if="crfFormses[crfFormIndex].module.includes('JWTIPSZL')" :formModel="model" :type="crfFormses[crfFormIndex].type"></JWTIPSZL>

                        <!-- 既往外科手术治疗改：既往脾切除手术 -->
                        <JWWKSSZL v-if="crfFormses[crfFormIndex].module.includes('JWWKSSZL')" :formModel="model" :type="crfFormses[crfFormIndex].type"></JWWKSSZL>

                        <!-- 既往内镜治疗 -->
                        <JWNJZL v-if="crfFormses[crfFormIndex].module.includes('JWNJZL')" :formModel="model" :type="crfFormses[crfFormIndex].type"></JWNJZL>

                        <!-- 既往药物治疗改：既往门脉高压药物治疗 -->
                        <JWYWZL v-if="crfFormses[crfFormIndex].module.includes('JWYWZL')" :formModel="model" :type="crfFormses[crfFormIndex].type"></JWYWZL>

                        <!-- 肝脏失代偿（改成PSVD并发症）（门高压并发症） -->
                        <!-- <GZSDC v-if="crfFormses[crfFormIndex].module.includes('GZSDC')" :formModel="model" prefix="【门高压并发症】"
                                :type="crfFormses[crfFormIndex].type"></GZSDC> -->
                        <!-- <div v-if="props.crfForm.type == 'V0肝穿点±2周'" :class="{'v0_btns':screencrf.size == 100}">
                            <button @click.prevent="model.lab = false"> 适用筛选期数据</button>
                            <button @click.prevent="model.lab = true" style="margin-left: 20px;">不适用筛选期数据</button>
                        </div>-->
                        <!-- 单独控制这几个的适用筛选按钮去掉 -->
                        <!-- <div v-if="model.lab">
                            <p>哈哈哈隐藏</p>
                            <p>{{ props.crfForm.type }}</p> -->

                              <p v-if="crfFormses[crfFormIndex].module.includes('XCGJNCG')" class="tishi">实验室检查开始，未做的检查请填写"ND"</p>
                              <!-- 血常规及尿常规 -->
                              <XCGJNCG v-if="crfFormses[crfFormIndex].module.includes('XCGJNCG')" :formModel="model" :type="crfFormses[crfFormIndex].type"></XCGJNCG>

                              <!-- 凝血功能 -->
                              <NXGN v-if="crfFormses[crfFormIndex].module.includes('NXGN')" :formModel="model" :type="crfFormses[crfFormIndex].type"></NXGN>

                              <!-- 血生化检查 -->
                              <XSHJC v-if="crfFormses[crfFormIndex].module.includes('XSHJC')" :formModel="model" :type="crfFormses[crfFormIndex].type"></XSHJC>

                              <!-- AFP -->
                              <AFP v-if="crfFormses[crfFormIndex].module.includes('AFP')" :formModel="model" :type="crfFormses[crfFormIndex].type"></AFP>

                              <!-- 乙肝 -->
                              <YGHCVHIV v-if="crfFormses[crfFormIndex].module.includes('YGHCVHIV')" :formModel="model" :type="crfFormses[crfFormIndex].type"></YGHCVHIV>

                              <!-- 自身免疫性肝病抗体谱 -->
                              <ANAANCA v-if="crfFormses[crfFormIndex].module.includes('ANAANCA')" :formModel="model" :type="crfFormses[crfFormIndex].type"></ANAANCA>

                              <!-- 免疫球蛋白定量 -->
                              <MYQDB v-if="crfFormses[crfFormIndex].module.includes('MYQDB')" :formModel="model" :type="crfFormses[crfFormIndex].type"></MYQDB>
                        <!-- </div> -->
                        <!-- 甲状腺功能 -->
                        <JZXGN v-if="crfFormses[crfFormIndex].module.includes('JZXGN')" :formModel="model" :type="crfFormses[crfFormIndex].type"></JZXGN>

                        <!-- 心电图 -->
                        <XDT ref="xdt" v-if="crfFormses[crfFormIndex].module.includes('XDT')" :formModel="model" :type="crfFormses[crfFormIndex].type"></XDT>

                        <!-- 胃镜 -->
                        <WJ v-if="crfFormses[crfFormIndex].module.includes('WJ')" :formModel="model" :type="crfFormses[crfFormIndex].type"></WJ>

                        <!-- Fibroscan -->
                        <FIBROSCAN v-if="crfFormses[crfFormIndex].module.includes('FIBROSCAN')" :formModel="model" :type="crfFormses[crfFormIndex].type"></FIBROSCAN>

                        <!-- FIBROTOUCH -->
                        <FIBROTOUCH v-if="crfFormses[crfFormIndex].module.includes('FIBROTOUCH')" :formModel="model" :type="crfFormses[crfFormIndex].type"></FIBROTOUCH>

                        <!-- 腹部、腹水及门静脉B超 -->
                        <FBFSMJMBC v-if="crfFormses[crfFormIndex].module.includes('FBFSMJMBC')" :formModel="model" :type="crfFormses[crfFormIndex].type"></FBFSMJMBC>

                        <!-- 肺部CT平扫（可选） -->
                        <FBCT v-if="crfFormses[crfFormIndex].module.includes('FBCT')" :formModel="model" :type="crfFormses[crfFormIndex].type"></FBCT>

                        <!-- 门静脉CTV -->
                        <MJMCTV v-if="crfFormses[crfFormIndex].module.includes('MJMCTV')" :formModel="model" :type="crfFormses[crfFormIndex].type"></MJMCTV>

                        <!-- 肝脏增强CT -->
                        <GZZQCT v-if="crfFormses[crfFormIndex].module.includes('GZZQCT')" :formModel="model" :type="crfFormses[crfFormIndex].type"></GZZQCT>

                        <!-- 肝脏增强MR -->
                        <GZZQMR v-if="crfFormses[crfFormIndex].module.includes('GZZQMR')" :formModel="model" :type="crfFormses[crfFormIndex].type"></GZZQMR>

                        <!-- MRCP（可选） -->
                        <MRCP v-if="crfFormses[crfFormIndex].module.includes('MRCP')" :formModel="model" :type="crfFormses[crfFormIndex].type"></MRCP>

                        <!-- HVPG测定（可选） -->
                        <HVPGCD v-if="crfFormses[crfFormIndex].module.includes('HVPGCD')" :formModel="model" :type="crfFormses[crfFormIndex].type"></HVPGCD>

                        <!-- 病理报告 -->
                        <BLBG v-if="crfFormses[crfFormIndex].module.includes('BLBG')" :formModel="model" :type="crfFormses[crfFormIndex].type"></BLBG>

                        <!--不良事件记录-->
                        <BLSJJL v-if="crfFormses[crfFormIndex].module.includes('BLSJJL')" :formModel="model" :type="crfFormses[crfFormIndex].type"></BLSJJL>
                        <!-- <p>{{ model.fields[crfFormses[crfFormIndex].type]?.ctp }}</p> -->

                        <p v-if="crfFormIndex >1"  @click="isctpshow = !isctpshow" class="ctpstyle">CTP评分：{{ computedCtp !== null ? computedCtp : '缺失数据' }}</p>
                        <p v-if="crfFormIndex >1"  @click="ismeldshow = !ismeldshow" class="ctpstyle">MELD评分：{{ computedMeld !== null ? computedMeld : '缺失数据' }}</p>
                        <ZG v-if="crfFormIndex>2" :formModel="model" :type="crfFormses[crfFormIndex].type"></ZG>
                        <!-- 全外显子基因测序（可选）改为基因测序 -->
                        <QWXZJYCX v-if="crfFormses[crfFormIndex].module.includes('QWXZJYCX')" :formModel="model" :type="crfFormses[crfFormIndex].type"></QWXZJYCX>

                        <!-- 备份血样（可选） -->
                        <BFXY v-if="crfFormses[crfFormIndex].module.includes('BFXY')" :formModel="model" :type="crfFormses[crfFormIndex].type"></BFXY>


                      </el-form>
                    </section>
                  </el-col>
                </el-row>

          </template>
          <template #footer>
            <div :class="[no_access == 0?'no_access':'']" style="background-color: white;">
              <p v-if="no_access == 0" style="width: 400px;float: right;margin-right: 40px;">
                <el-button v-if="crfFormIndex > 1 && !commonStore.is_fully_checked&&  model.checkdata.ischeck == '是' &&( user.role.includes('0') || user.role.includes('2')) " style="background-color: #4ebc17;color: white;" @click="allcheck" >一键核查</el-button>
                <el-button type="primary" @click="handleCloseDrawer" >返回</el-button>
              </p>
            </div>
            <el-button @click="handleCloseDrawer">取消</el-button>
            <el-button v-if=" crfFormIndex>1&& !commonStore.is_fully_checked &&model.checkdata.ischeck == '是' && (user.role.includes('0') || user.role.includes('2'))" style="background-color: #626462;color: white;" @click="allcheck" >一键核查</el-button>
            <el-button type="primary" @click="Staging(formRef,crfFormses[crfFormIndex].type)">暂存本表单数据</el-button>
            <div style="padding-top: 10px;">
              <el-button type="primary" @click="submitForm(formRef,crfFormses[crfFormIndex].type)">完成并保存本次数据填入</el-button>
            </div>
          </template>
      </el-drawer>
      <el-dialog v-model="isctpshow" title="CTP" :width="`${40}%`" center>
        <div class="ctptxt">
          <!-- 显示有效的CTP项 -->
          <p v-for="(item, index) in Ctpitem" :key="index">{{ item }}</p>
          <!-- 显示缺失或无效的项 -->
          <p v-for="(item, index) in ctpMissing" :key="'miss-' + index">{{ item }}</p>
        </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="isctpshow = false">取消</el-button>
          <el-button type="primary" @click="isctpshow = false">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
      <el-dialog v-model="ismeldshow" title="MELD" :width="`${40}%`" center>
        <div class="ctptxt">
          <!-- 显示有效的MELD项 -->
          <p v-for="(item, index) in Melditem" :key="index">{{ item }}</p>
          <!-- 显示缺失或无效的项 -->
          <p v-for="(item, index) in meldMissing" :key="'miss-' + index">{{ item }}</p>
        </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="ismeldshow = false">取消</el-button>
          <el-button type="primary" @click="ismeldshow = false">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
     <el-dialog
        v-model="allshow"
        title="一键核查"
        width="500"
    >
        <span>确定全部完成核查吗？</span>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="allshow = false">取消</el-button>
            <el-button type="primary" @click="allcheck1" >确定</el-button>
        </div>
        </template>
    </el-dialog>
</template>

<style lang="scss" scoped>
.ctpstyle{
  // display: inline-block;
  font-size: 22px;
  cursor: pointer;
  text-decoration: underline;
}
.ctptxt{
  font-size: 18px;
}
.box :deep(.el-form-item__label){
  overflow: hidden;
  word-spacing: nowrap;
  color: red;
}
.no_access{
  user-select: none;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
  // background-color: black;
  // opacity: .5;
}
.v0_btns{
  position: relative;
  top: 14px;
}
.sidebar {
    position: fixed;
    top: 30px;
    left: 10px;
    font-size: 18px;
}
.box{
    position: relative;

}
.pp{
    position: absolute;
    top: 38px;

    color: rgba(0, 0, 0, 0.7);
    font-size: 12px;
}
.picker{
    position:fixed;
    top:15px;
    /* left: 270px; */
    left: 670px;


}
@media screen and (max-width:1000px ) {
  .picker{
    position:fixed;
    top:84px;
    /* left: 270px; */
    left: 15px;
    z-index: 100;
    background-color: white;

  }
}

.tishi{
      font-size: 16px;
      color: rgb(240, 102, 102);
      /* padding-left: 15px; */
      margin: 0;
    }
    ::v-deep .el-row{
      width: 100%;

    }
</style>
